import Enumerator from '../global/Enumerator';

export const verificationsInterviewDetailsOptions = [
  'none',
  'in_person',
  'video_conference',
  'phone_call'
];

export class VerificationsInterviewDetailsOption extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'in_person';
        break;
      case '2':
        correctOption = 'video_conference';
        break;
      case '3':
        correctOption = 'phone_call';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

VerificationsInterviewDetailsOption.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  in_person: {
    get title() {
      return 'In person';
    }
  },
  video_conference: {
    get title() {
      return 'Video conference';
    }
  },
  phone_call: {
    get title() {
      return 'Phone call';
    }
  }
});

export default {
  verificationsInterviewDetailsOptions,
  VerificationsInterviewDetailsOption
};
